interface CheckmarkIconProps {
  className?: string
}

export default function CheckmarkIcon({ className }: CheckmarkIconProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8 26 L18 36 L40 12"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="empty-state-check"
      />
    </svg>
  )
}
